export const FORM_VIEW = {
  OTP_VIEW: 'OTP_VIEW',
  PHONE_VIEW: 'PHONE_VIEW',
  ORG_VIEW: 'ORG_VIEW',
};
